import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { Card, TextField, Radio, Text } from '@nike/eds'

import { CardTitle, Label } from '../../../components/FormComponents'

function ConnectionDetails() {
  const { register, watch, setValue } = useFormContext()
  const name = 'settings.oracledb'
  const auth = watch(`${name}.auth.type`, '')
  const encryption = watch(`${name}.connectionEncryption.type`, 'ssl')

  const resetAuth = () => {
    setValue(`${name}.auth.type`, '')
    setValue(`${name}.auth`, {})
  }
  useEffect(() => {
    setValue(`${name}.connectionEncryption.type`, 'ssl')
  }, [setValue])

  return (
    <Card padding={24}>
      <CardTitle title='Connection Details' />
      <div className={'eds-spacing--mb-16 eds-grid eds-grid--m-cols-2'}>
        <div>
          <TextField
            {...register(`${name}.host`, { required: true })}
            className='eds-spacing--mb-16'
            placeholder='oracledb.host'
            label={<Label label='Host' required />}
          />
        </div>
        <div>
          <TextField
            {...register(`${name}.port`, { required: true, valueAsNumber: true })}
            className='eds-spacing--mb-16'
            placeholder='5432'
            defaultValue={5432}
            label={<Label label='Port' />}
          />
        </div>
      </div>
      <CardTitle
        title='Auth'
        tooltip='Information for auth against the database. All requests will be made using the default schema for the configured user unless the tables and/or views are prefixed with a schema name (e.g. my_schema.my_table).'
      />
      <div className={'eds-spacing--mb-24 eds-grid eds-grid--m-cols-6'}>
        <Radio
          id='auth_none'
          value=''
          onClick={() => resetAuth()}
          checked={!auth}
          label={<Text font='body-2'>None (Default)</Text>}
        />
        <Radio
          id='auth_basic'
          value='basic'
          checked={!!auth}
          onClick={(e) => setValue(`${name}.auth.type`, e.target.value)}
          label={<Text font='body-2'>Basic</Text>}
        />
      </div>
      {auth && (
        <div className={'eds-grid eds-grid--m-cols-2'}>
          <div>
            <TextField
              {...register(`${name}.auth.basic.user`)}
              className='eds-spacing--mb-16'
              label='Username'
              subtitle='The user name to connect with'
            />
          </div>
          <div>
            <TextField
              {...register(`${name}.auth.basic.password`)}
              className='eds-spacing--mb-16'
              label='Password'
              subtitle='The password to connect with'
            />
          </div>
        </div>
      )}
      <CardTitle
        title='Connection Encryption'
        tooltip='The mode for making encrypted connections. If not defined then this defaults to ssl with no additional settings'
      />
      <div className={'eds-spacing--mb-24    eds-grid eds-grid--m-cols-4'}>
        <Radio
          name='encryption'
          id='encryption_ssl'
          value='ssl'
          checked={encryption === 'ssl'}
          onClick={(e) => setValue(`${name}.connectionEncryption.type`, e.target.value)}
          label={<Text font='body-2'>SSL</Text>}
        />
        <Radio
          name='encryption'
          id='encryption_unencrypted'
          value='unencrypted'
          checked={encryption === 'unencrypted'}
          onClick={(e) => setValue(`${name}.connectionEncryption.type`, e.target.value)}
          label={<Text font='body-2'>Unencrypted</Text>}
        />
      </div>
      {encryption === 'ssl' && (
        <TextField
          {...register(`${name}.connectionEncryption.ssl.certificateDN`)}
          className='eds-spacing--mb-16'
          label={
            <Label
              label='Certificate DN'
              required
              tooltip='The distinguished name of the certificate on the server.'
            />
          }
        />
      )}
      <TextField
        {...register(`${name}.sid`)}
        className='eds-spacing--mb-16'
        label={
          <Label
            label='SID'
            tooltip='The Oracle System Identifier of the database to connect to. Either this value or serviceName must be set.'
          />
        }
      />
      <TextField
        {...register(`${name}.serviceName`)}
        className='eds-spacing--mb-16'
        label={
          <Label
            label='Service Name'
            required
            tooltip='The Oracle service name to connect to. Either this value or sid must be set.
          '
          />
        }
      />
    </Card>
  )
}

export default ConnectionDetails
